import styled from "styled-components";

export const StyledFooter = styled.footer`
  height: 62px;
  background: var(--tws-white);
  border-top: 1px solid var(--tws-border);
  z-index: 1030;

  a {
    color: var(--tws-text-muted);

    &[aria-current="page"] {
      color: var(--tws-brown);
    }
  }
`;

export const StyledDesktopFooter = styled.footer`
  background: var(--tws-white);
  border-top: 1px solid var(--tws-border);
  margin-top: auto;

  a:hover {
    color: var(--tws-brown) !important;
  }
`;
